import api from './client';

export async function linkAdminSlackAccount(
  companyId: string,
  slackToken: string
) {
  const { data } = await api.post(
    `/slack/companies/${companyId}/admin/link-account`,
    { slackToken }
  );
  return data;
}

export async function linkSlackWorkspace(
  companyId: string,
  slackToken: string
) {
  const { data } = await api.post(
    `/slack/companies/${companyId}/workspace/link`,
    { slackToken }
  );
  return data;
}
